const Headline = (props) => {
    return (
        <div className='headline'>
            <p className='title'>{props.title}</p>
            <div className='headline-rule'></div>
            <p className='sub-title'>{props.subTitle}</p>
        </div>
    )
}

export default Headline
